











































import {
  IEmployee,
  ITimeOffRequest,
  IUserData,
  TimeOffRequest,
  TimeOffStateEnum
} from '@/models';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

import { PropType } from 'vue';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import moment from 'moment';

export default mixins(auth).extend({
  components: { ConfirmationDialog },

  props: {
    event: {
      type: Object as PropType<ITimeOffRequest>
    },
    errorMessage: String
  },

  data() {
    return {
      TimeOffStateEnum
    };
  },

  computed: {
    isUserApprover(): boolean {
      return this.event.approvers!.some(
        approver => (approver.approver as IUserData).id == this.currentUser.id
      );
    },

    isTimeOffDraft(): boolean {
      return this.event.state == TimeOffStateEnum.Draft;
    },

    // Owner of the personal request can cancel anytime when in submitted state.
    // Once approved and in the past, the owner can't cancel
    // If user is approver or SA they can cancel anytime
    canCancel(): boolean {
      let canCancel = false;
      if (this.isUserOwner) {
        canCancel =
          this.event.state == TimeOffStateEnum.Submitted ||
          this.isTimeOffDraft ||
          (moment(this.event.start as string).isSameOrAfter(
            moment().utc(true)
          ) &&
            this.event.state == TimeOffStateEnum.Approved);
      } else if (
        this.event.state == TimeOffStateEnum.Approved &&
        (this.isUserApprover || this.isUserHRPersonnel)
      ) {
        canCancel = true;
      }
      return canCancel;
    },

    canSubmit(): boolean {
      return this.isTimeOffDraft && this.isTimeOffOwner;
    },

    isTimeOffOwner(): boolean {
      return this.getCurrentUserFullName == this.event.owner;
    },

    isUserOwner(): boolean {
      return (this.event.employee as IEmployee).id == this.currentUser.employee;
    },

    cancelText(): string {
      return this.event.state == TimeOffStateEnum.Approved
        ? 'Cancel Approved Request'
        : 'Cancel';
    },

    canRejectOrApproveState(): boolean {
      return (
        this.isUserApprover && this.event.state == TimeOffStateEnum.Submitted
      );
    },

    buttonPositionStyle(): string {
      return this.canRejectOrApproveState && this.canCancel
        ? 'justify-space-between'
        : 'justify-end';
    }
  },

  methods: {
    openCommentDialog(state: TimeOffStateEnum) {
      this.$emit('openCommentDialog', { request: this.event, state });
    }
  }
});
